// extracted by mini-css-extract-plugin
export default {"label":"LX_yX5_U","borderer":"gOiYbyhY","input":"tRt6HYMS","icons":"YQuCCvml"};